/* eslint-disable */
import _ from 'lodash';

export const filterEjecuciones = (ejecuciones) => {
  return ejecuciones.length ? ejecuciones[ejecuciones.length - 1] : [];
};

export const serverFilterResult = (json) => {
  const newJson = json; /*  JSON.parse(json) */

  let result = [];
  if (!_.isEmpty(newJson)) {
    Object.keys(newJson).map((keyA) => {
      if (_.isObject(newJson[keyA])) {
        Object.keys(newJson[keyA]).map((keyB) => {
          Object.keys(newJson[keyA][keyB]).map((keyC) => {
            Object.keys(newJson[keyA][keyB][keyC]).map((keyD) => {
              Object.keys(newJson[keyA][keyB][keyC][keyD]).map((keyE) => {
                if (!_.isEmpty(newJson[keyA][keyB][keyC][keyD][keyE])) {
                  result.push(newJson[keyA][keyB][keyC][keyD][keyE]);
                }
              });
            });
          });
        });
      }
    });
  }
  return result;
};

export const serverFilterResultInternacion = (json) => {
  const newJson = json; /* JSON.parse(json) */
  let result = [];
  if (!_.isEmpty(newJson)) {
    Object.keys(newJson).map((keyA) => {
      if (_.isObject(newJson[keyA])) {
        Object.keys(newJson[keyA]).map((keyB) => {
          Object.keys(newJson[keyA][keyB]).map((keyC) => {
            Object.keys(newJson[keyA][keyB][keyC]).map((keyD) => {
              /* if(newJson[keyA][keyB][keyC][keyD].length > 1){

                result = newJson[keyA][keyB][keyC][keyD];
              }; */

              Object.keys(newJson[keyA][keyB][keyC][keyD]).map((keyE) => {
                ////// result.push(Object.keys(newJson[keyA][keyB][keyC][keyD][keyE]));
                if (Object.keys(newJson[keyA][keyB][keyC][keyD][keyE]).length > 1) {
                  result.push(newJson[keyA][keyB][keyC][keyD][keyE]);
                }

                /*  if( Object.keys(newJson[keyA][keyB][keyC][keyD][keyE]) !== 'Filas afectadas'){
             
                    result.push(newJson[keyA][keyB][keyC][keyD][keyE]);
                }*/
              });
            });
          });
        });
      }
    });
  }
  return result;
};

export const remplaceNull = (json) => {
  const result = [];
  if (!_.isEmpty(json)) {
    for (let i = 0; i < json.length; i += 1) {
      if (json[i].tipo === null) {
        const newItem = json[i];
        newItem.tipo = 'G';
        result.push(newItem);
      } else {
        result.push(json[i]);
      }
    }
  }
  return result;
};

export const serverFilterResultSubtotal = (json) => {
  const newJson = json; /*  JSON.parse(json) */
  let result = [];
  if (!_.isEmpty(newJson)) {
    Object.keys(newJson).map((keyA) => {
      if (_.isObject(newJson[keyA])) {
        Object.keys(newJson[keyA]).map((keyB) => {
          Object.keys(newJson[keyA][keyB]).map((keyC) => {
            if (_.isArray(newJson[keyA][keyB][keyC])) {
              Object.keys(newJson[keyA][keyB][keyC]).map((KeyD) => {
                Object.keys(newJson[keyA][keyB][keyC][KeyD]).map((keyE) => {
                  if (Object.keys(newJson[keyA][keyB][keyC][KeyD][keyE]).length > 1) {
                    result = newJson[keyA][keyB][keyC][KeyD][keyE];
                  }
                });
              });
            }
          });
        });
      }
    });
  }
  return result;
};

export const formatCurrency = (x) => {
  const z = parseFloat(x).toFixed(2).replace('.', ',');
  return z.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
};
